import { GameStatues, GetPlayerGameVotesPayload, IGameAttendancesVotes } from "./../../../";
import server from "../Server";
import withErrorCheck from "../CheckError";

export const GetPlayerGamesVotes = async (payload: GetPlayerGameVotesPayload): Promise<IGameAttendancesVotes[]> => {
  return withErrorCheck(
    await server
      .from("GameAttendanceVotes")
      .select("*, GameAttendances!inner(*)")
      .eq("player_id", payload.id)
      .eq("GameAttendances.game_id", payload.gameId)
  );
};
